import service from './base'

// 获取路由映射列表
export function getRouteMapList() {
  return service({
    url: `/apis/v1/privilege/page-configs`,
    method: 'get'
  })
}
